import { Trans } from 'react-i18next';
import VideoPoster from '../../assets/cff755ecde15f09f.jpg';
import Video from '../../assets/cff755ecde15f09f.mp4';
import { FrameLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { H10, SubH1 } from '../../common/common-text';
import i18n from '../../common/i18n/i18n';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';
import useVisualViewportHeight from '../../hooks/useVisualViewportHeight';

const CleanDryRoomSection1 = () => {
  const { horizontal: padding, topSectionBottom: topSectionBottom } = useResponsivePadding(/*{ mode: 'fixed' }*/);
  const viewheight = useVisualViewportHeight();
  const { isMobile, isPad, isDesktop, isTablet } = useDeviceType();
  const isEng = ['en', 'en-mobile'].includes(i18n.language);
  const isChina = ['zh', 'zh-mobile'].includes(i18n.language);

  return (
    <VerticalLayout style={{
      background: '#d5d5d5',
      ...(isMobile && !isPad ? { height: viewheight } : {}),
    }}>
      <FrameLayout>
        <video
          src={Video}
          autoPlay
          muted
          loop
          playsInline
          poster={VideoPoster}
          style={{
            width: '100%',
            height: isMobile && !isPad ? '100%' : 'auto',
            display: 'block',
            objectFit: 'cover',
          }}
        />
        <SubH1 style={{
          color: 'white',
          position: 'absolute',
          bottom: (isMobile && !isPad) ? isEng ? '246px' : isChina ? '163px' : '185px' : `${topSectionBottom}px`,
          left: `${padding}px`,
          width: isMobile ? '90%' : `calc((${isTablet ? 60 : isPad ? 60 : 50}% - ${padding}px))`,
          transform: isPad ? 'scale(0.80)' : 'scale(1)',
          transformOrigin: 'left bottom'
        }}>Cleanroom &<br />Dryroom Engineering</SubH1>
        <H10
          style={{
            width: isMobile && !isPad ? `calc(100% - ${padding * 2}px)` : pxToRem(510),
            color: 'white',
            position: 'absolute',
            bottom: isMobile && !isPad ? '0px' : `${topSectionBottom}px`,
            left: isMobile && !isPad ? `${padding}px` : undefined,
            right: isMobile && !isPad ? undefined : `${padding}px`,
            transform: isPad ? 'scale(0.85)' : 'scale(1)',
            transformOrigin: 'right bottom',
            ...(isMobile && !isPad
              && { height: isEng ? '234px' : isChina ? '146px' : `178px` }),
          }}
        >
          <Trans i18nKey='비비테크는 고청정 산업에 특화된 클린룸 및 드라이룸의 설계·시공 기술을 보유하고 있으며,온도, 습도, 미세입자, 정전기까지 철저하게 제어하여 민감한 공정에 최적화된 솔루션을 제공합니다. 또한, 극저습 환경을 효율적으로 구현해, 이차전지(EV Battery) 제조의 품질 향상과 공정 안정성 확보에 기여하고 있습니다.'/>
        </H10>
      </FrameLayout>
    </VerticalLayout>
  );
};

export default CleanDryRoomSection1;
